import {domain} from '../common.js';
import clientUUID from '@/client.js';

export const loadJudete = (lang) => fetch(`${domain}/${lang}/gaz/judete`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});

export const loadLocalitati = (lang, judet) => fetch(`${domain}/${lang}/gaz/judete/${judet}/localitati`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});
